module.exports = __webpack_public_path__ + "static/media/remove-document.8b7347a0.svg";